"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.tsx
var src_exports = {};
__export(src_exports, {
  DarkModeProvider: () => DarkModeProvider,
  useDarkMode: () => useDarkMode
});
module.exports = __toCommonJS(src_exports);
var import_react2 = require("react");

// src/useLocalStorage.ts
var import_react = require("react");
function useLocalStorage(key, initialValue) {
  const [storedValue, setStoredValue] = (0, import_react.useState)(() => {
    if (typeof window === "undefined") {
      return initialValue;
    }
    try {
      const item = window.localStorage.getItem(key);
      if (!item)
        window.localStorage.setItem(key, JSON.stringify(initialValue));
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.log(error);
      return initialValue;
    }
  });
  const setValue = (value) => {
    try {
      const valueToStore = value instanceof Function ? value(storedValue) : value;
      setStoredValue(valueToStore);
      if (typeof window !== "undefined") {
        window.localStorage.setItem(key, JSON.stringify(valueToStore));
      }
    } catch (error) {
      console.log(error);
    }
  };
  return [storedValue, setValue];
}

// src/index.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var DarkModeContext = (0, import_react2.createContext)({
  mode: "system",
  setMode: () => {
  }
});
var preferDarkQuery = "(prefers-color-scheme: dark)";
var mediaQueryEventTarget = typeof window !== "undefined" ? window.matchMedia(preferDarkQuery) : null;
var DarkModeProvider = ({ children }) => {
  const [mode, setMode] = useLocalStorage("scheme-mode", "system");
  (0, import_react2.useEffect)(() => {
    const listener = (e) => {
      if (mode === "system")
        setClassOnDocument(e.matches);
    };
    mediaQueryEventTarget == null ? void 0 : mediaQueryEventTarget.addEventListener("change", listener);
    return () => mediaQueryEventTarget == null ? void 0 : mediaQueryEventTarget.removeEventListener("change", listener);
  }, [mode]);
  (0, import_react2.useEffect)(() => {
    if (mode === "dark")
      return setClassOnDocument(true);
    if (mode === "light")
      return setClassOnDocument(false);
    setClassOnDocument(window.matchMedia(preferDarkQuery).matches);
  }, [mode]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(DarkModeContext.Provider, { value: { mode, setMode }, children });
};
var setClassOnDocument = (darkTheme) => {
  const classNameDark = "dark-mode";
  const classNameLight = "light-mode";
  const element = typeof window !== "undefined" ? document.querySelector("html") : null;
  if (!element)
    return;
  element.classList.add(darkTheme ? classNameDark : classNameLight);
  element.classList.remove(darkTheme ? classNameLight : classNameDark);
};
var useDarkMode = () => (0, import_react2.useContext)(DarkModeContext);
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  DarkModeProvider,
  useDarkMode
});
